import * as RC from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { Icon } from './Icon';

interface CheckboxProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  id?: string;
}

export function Checkbox({ checked, onChange, label, id }: CheckboxProps) {
  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-3)',
        minHeight: 44,
        padding: 'var(--space-2) 0',
        cursor: 'pointer',
      }}
      htmlFor={id}
    >
      <RC.Root
        id={id}
        className="cb"
        checked={checked}
        onCheckedChange={(c) => onChange(c === true)}
      >
        <RC.Indicator>
          <Icon icon={Check} size={16} strokeWidth={2.5} />
        </RC.Indicator>
      </RC.Root>
      <span>{label}</span>
    </label>
  );
}
